import { INPShift } from "../store/npShiftsReducer";

export const SET_NP_SHIFTS = "SET_NP_SHIFTS";
export const ADD_NP_SHIFT = "ADD_NP_SHIFT";

export const SetNPShifts = (nps: INPShift[]) => {
    return { type: SET_NP_SHIFTS, nps };
};
export const AddNPShift = (np: INPShift) => {
    return { type: ADD_NP_SHIFT, np };
};
